
import React from 'react';
import PropTypes from 'prop-types';
import { Star } from '../../../../../../react-konva';

import nodesCommonPropTypes from '../nodesCommonPropTypes';

const StarNode = ({
  id,
  name,
  fill = '#000',
  x,
  y,
  innerRadius,
  outerRadius,
  numPoints = 5,
  scaleX,
  scaleY,
  rotation,
  annotationEvents,
  stroke,
  strokeWidth,
  shadowOffsetX,
  shadowOffsetY,
  shadowBlur,
  shadowColor,
  shadowOpacity,
  opacity,
  ...otherProps
}) => (
  <Star
    id={id}
    name={name}
    rotation={rotation}
    scaleX={scaleX}
    scaleY={scaleY}
    stroke={stroke}
    strokeWidth={strokeWidth}
    shadowOffsetX={shadowOffsetX}
    shadowOffsetY={shadowOffsetY}
    shadowBlur={shadowBlur}
    shadowColor={shadowColor}
    shadowOpacity={shadowOpacity}
    fill={fill}
    x={x}
    y={y}
    numPoints={numPoints}
    innerRadius={innerRadius}
    outerRadius={outerRadius}
    offsetX={-outerRadius}
    offsetY={-outerRadius}
    opacity={opacity}
    {...annotationEvents}
    {...otherProps}
  />
);

StarNode.propTypes = {
  ...nodesCommonPropTypes.definitions,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  annotationEvents: PropTypes.instanceOf(Object).isRequired,
  innerRadius: PropTypes.number.isRequired,
  outerRadius: PropTypes.number.isRequired,
  fill: PropTypes.string,
  numPoints: PropTypes.number,
};

export default StarNode;
